import * as z from 'zod'

export const SarListSchema = z.object({
  companyId: z.number().nullable().optional(),
  onlyMyCompanies: z.boolean().optional(),
  status: z.string().nullable().optional(),
  page: z.number().int().positive().optional(),
  size: z.number().int().positive().optional()
})
